var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('[[[Brak dostępu]]]')))]),_c('p',[_vm._v(_vm._s(_vm.$t('[[[By uzyskać dostęp do aplikacji musisz zaakceptować wszystkie regulaminy]]]')))])])}
var staticRenderFns = []

export { render, staticRenderFns }